import { isSessionParticipantsListEnabled } from '../../../../../../data/filters/schedule/isSessionParticipantsListEnabled';

/**
 * @function isParticipantsButtonVisible
 * @description
 * Determines if the participants button should be visible for the given event
 * and session.
 *
 * @param {Object} event - The event that the session is part of.
 * @param {Object} session - The session to check.
 *
 * @returns {Boolean}   `true` if the participants button should be visible,
 *                      `false` otherwise.
 */
export function isParticipantsButtonVisible(event, session) {
    return (
        isSessionParticipantsListEnabled(session, event.settings) &&
        session.is_selectable
    );
}
